import { styled } from 'styled-components';
import { flexMixin, textMixin } from '@styles/mixins';
import { colors } from '@styles';

export const StyledLink = styled.a`
    cursor: pointer;
`;
export const StyledSpan = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 400,
    })};
    display: block;
    width: 100%;
    ${flexMixin('column', 'center', 'flex-start')};
`;

export const TextWrapper = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
`;

export const DateWrapper = styled.div`
    ${flexMixin('column', 'center', 'flex-start')};
    flex-wrap: wrap;
    margin-left: 5px;
`;
export const CSpan = styled.div`
    ${textMixin({
        fontSize: '14px',
        fontWeight: 500,
    })};
    color: ${colors.blackText};
`;
